export const columnas = [
  { label: "Fecha Actualización", key: "fecha" },
  { label: "Vivienda", key: "direccion" },
  { label: "Copropietarios", key: "copropietarios" },
  { label: "Vehículos", key: "vehiculos" },
  { label: "Mascotas", key: "mascotas" },
  { label: "Autorizados", key: "autorizados" },
  { label: "Contactos Emergencia", key: "contactosEmergencia" },
  { label: "Espacios", key: "espacios" },
  { label: "Coeficiente Apartamento", key: "coeficiente" },
  { label: "Coeficiente Total", key: "coeficienteTotal" },
];
export const CONFIGS = {
  residentes: {
    titulo: 'Gestionar Residentes',
    campos: ['nombre_residente', 'cedula_residente', 'telefono_residente', 'tipo_residente', 'correo_residente', 'genero_residente'],
    labels: ['Nombre completo', 'Cédula', 'Teléfono', 'Tipo de residente', 'Correo electrónico', 'Género'],
    types: ['text', 'text', 'text', 'select', 'email', 'select'],
    placeholders: ['Nombre completo del residente', 'Número de cédula', 'Número de teléfono', '', 'correo@ejemplo.com', ''],
    opciones: {
      tipo_residente: [
        { value: '', text: 'Selecciona' },
        { value: 'PROPIETARIO', text: 'Propietario' },
        { value: 'RESIDENTE', text: 'Residente' },
        { value: 'LOCATARIO', text: 'Locatario' },
        { value: 'FAMILIAR', text: 'Familiar' },
        { value: 'PAREJA', text: 'Pareja' }
      ],
      genero_residente: [
        { value: '', text: 'Selecciona' },
        { value: 'MASCULINO', text: 'Masculino' },
        { value: 'FEMENINO', text: 'Femenino' },
        { value: 'NO_ESPECIFICA', text: 'Prefiere no especificar' }
      ]
    },
    validaciones: {
      nombre_residente: (v) => !v ? "El nombre es obligatorio" : null,
      cedula_residente: (v) => {
        if (!v) return "La cédula es obligatoria";
        if (!/^\d+$/.test(v)) return "La cédula debe contener solo números";
        if (v.length < 6 || v.length > 12) return "La cédula debe tener entre 6 y 12 dígitos";
        return null;
      },
      telefono_residente: (v) => !v ? "El teléfono es obligatorio" : null,
      tipo_residente: (v) => !v ? "El tipo de residente es obligatorio" : null,
      
      genero_residente: (v) => !v ? "El género es obligatorio" : null,
    }
  },
  vehiculos: {
    titulo: 'Gestionar Vehículos',
    campos: ['marca_carro', 'color_carro', 'placa', 'parqueadero'],
    labels: ['Marca', 'Color', 'Placa' , 'Parqueadero asignado'],
    types: ['text', 'text', 'text', 'text'],
    placeholders: ['Marca del vehículo', 'Color del vehículo', 'ABC123', 'Número del parqueadero'],
    validaciones: {
      placa: (v) => v && (v.length < 5 || v.length > 6) ? "La placa debe tener entre 5 y 6 caracteres" : null,
    }
  },
  mascotas: {
    titulo: 'Gestionar Mascotas',
    campos: ['nombre_mascota', 'tipo_mascota'],
    labels: ['Nombre de la mascota', 'Tipo de mascota'],
    types: ['text', 'select'],
    placeholders: ['Nombre de la mascota', ''],
    opciones: {
      tipo_mascota: [
        { value: '', text: 'Selecciona' },
        { value: 'PERRO', text: 'PERRO' },
        { value: 'GATO', text: 'GATO' },
        { value: 'PAJARO', text: 'PÁJARO' },
      ]
    }
  },
  autorizados: {
    titulo: 'Gestionar Autorizados',
    campos: ['nombre_autorizado', 'cedula_autorizado', 'tipo_relacion_autorizado'],
    labels: ['Nombre completo', 'Cédula', 'Tipo de relación'],
    types: ['text', 'text', 'select'],
    placeholders: ['Nombre completo del autorizado', 'Número de cédula', ''],
    opciones: {
      tipo_relacion_autorizado: [
        { value: '', text: 'Selecciona' },
        { value: 'FAMILIAR', text: 'Familiar' },
        { value: 'AMIGO', text: 'Amigo' },
        { value: 'EMPLEADO', text: 'Empleado' },
      ]
    },
    validaciones: {
      nombre_autorizado: (v) => !v ? "El nombre es obligatorio" : null,
      cedula_autorizado: (v) => {
        if (!v) return "La cédula es obligatoria";
        if (!/^\d+$/.test(v)) return "La cédula debe contener solo números";
        if (v.length < 6 || v.length > 12) return "La cédula debe tener entre 6 y 12 dígitos";
        return null;
      },
      tipo_relacion_autorizado: (v) => !v ? "El tipo de relación es obligatorio" : null,
    }
  },
  espacios: {
    titulo: 'Gestionar Espacios',
    campos: ['espacio_tipo', 'espacio_identificador', 'espacio_coeficiente'],
    labels: ['Tipo', 'Identificador', 'Coeficiente'],
    types: ['select', 'text', 'number'],
    placeholders: ['', 'Número/ID del espacio', '0.05'],
    opciones: {
      espacio_tipo: [
        { value: '', text: 'Selecciona' },
        { value: 'PARQUEADERO', text: 'PARQUEADERO' },
        { value: 'BODEGA', text: 'BODEGA' },
        { value: 'CUARTO_UTIL', text: 'CUARTO ÚTIL' }
      ]
    },
    validaciones: {
      espacio_tipo: (v) => !v ? "El tipo es obligatorio" : null,
      espacio_identificador: (v) => !v ? "El identificador es obligatorio" : null,
    }
  },
  contactos_emergencia: {
    titulo: 'Gestionar Contactos de Emergencia',
    campos: ['nombre_contacto_emergencia', 'telefono_contacto_emergencia', 'descripcion_contacto_emergencia'],
    labels: ['Nombre completo', 'Teléfono', 'Descripción'],
    types: ['text', 'text', 'text'],
    placeholders: ['Nombre del contacto', 'Número de teléfono', 'Parentesco o relación'],
    validaciones: {
      nombre_contacto_emergencia: (v) => !v ? "El nombre es obligatorio" : null,
      telefono_contacto_emergencia: (v) => !v ? "El teléfono es obligatorio" : null,
      descripcion_contacto_emergencia: (v) => !v ? "La descripción es obligatoria" : null,
    }
  }
};
export const extraerDatosNumerados = (fila, prefijos, maxItems = 10) => {
  const datos = [];
  for (let i = 1; i <= maxItems; i++) {
    const item = {};
    let tieneAlgunDato = false;

    prefijos.forEach(prefijo => {
      const clave = `${prefijo}_${i}`;
      const valor = fila[clave];
      if (valor && valor.toString().trim() !== '') {
        item[prefijo] = valor;
        tieneAlgunDato = true;
      }
    });

    if (tieneAlgunDato) {
      item.index = i;
      datos.push(item);
    }
  }
  return datos;
};
export const generarFormularioHTML = (config, valores = {}) => {
  return config.campos.map((campo, index) => {
    const label = config.labels[index];
    const type = config.types[index];
    const placeholder = config.placeholders[index];
    const valor = valores[campo] || '';

    if (type === 'select') {
      const opciones = config.opciones[campo] || [];
      const options = opciones.map(opt =>
        `<option value="${opt.value}" ${valor === opt.value ? 'selected' : ''}>${opt.text}</option>`
      ).join('');

      return `
        <div style="display: flex; flex-direction: column; gap: 8px;">
          <label style="font-size: 14px; font-weight: 500;">${label}</label>
          <select id="${campo}" style="width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; background: white; box-sizing: border-box;">
            ${options}
          </select>
        </div>
      `;
    } else {
      return `
        <div style="display: flex; flex-direction: column; gap: 8px;">
          <label style="font-size: 14px; font-weight: 500;">${label}</label>
          <input id="${campo}" type="${type}" value="${valor}" 
            style="width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; box-sizing: border-box;" 
            placeholder="${placeholder}" ${campo === 'placa' ? 'maxlength="6"' : ''}>
        </div>
      `;
    }
  }).join('');
};
export const generarTablaConAcciones = (datos, config) => {
  if (datos.length === 0) {
    return `<div style="padding: 20px; text-align: center; color: #666;">
      No hay ${config.titulo.toLowerCase().replace('gestionar ', '')} registrados
    </div>`;
  }

  const headers = [
    ...config.labels.map(label => `<th style="border: 1px solid #ddd; padding: 8px;">${label}</th>`),
    `<th style="border: 1px solid #ddd; padding: 8px; width: 100px;">Acciones</th>`
  ].join('');

  const filas = datos.map((item, index) => {
    const celdas = config.campos.map(campo => {
      const valor = item[campo] || '';
      return `<td style="border: 1px solid #ddd; padding: 8px;">${valor}</td>`;
    }).join('');

    const botones = `
      <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
        <button onclick="editarItem(${index})" style="background: #007bff; color: white; border: none; padding: 4px 8px; margin: 0 2px; border-radius: 4px; cursor: pointer;">✏️</button>
        <button onclick="eliminarItem(${index})" style="background: #dc3545; color: white; border: none; padding: 4px 8px; margin: 0 2px; border-radius: 4px; cursor: pointer;">🗑️</button>
      </td>
    `;

    return `<tr>${celdas}${botones}</tr>`;
  }).join('');

  return `
    <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; border-radius: 8px; padding: 16px;">
      <h4 style="margin: 0 0 16px 0;">${config.titulo.replace('Gestionar ', '')}</h4>
      <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
        <thead><tr style="background: #f5f5f5;">${headers}</tr></thead>
        <tbody>${filas}</tbody>
      </table>
    </div>
  `;
};
export const actualizarDatosLocal = (datosActuales, filaOriginal, tipo) => {
  const config = CONFIGS[tipo];
  const datosActualizados = extraerDatosNumerados(filaOriginal, config.campos);
  datosActuales.length = 0;
  datosActuales.push(...datosActualizados);

  return datosActuales;
};
export const calcularCoeficienteTotal = (fila) => {
  const coeficienteApartamento = parseFloat(fila.coeficiente) || 0;
  let coeficientesEspacios = 0;
  for (let i = 1; i <= 10; i++) {
    const coefEspacio = fila[`espacio_coeficiente_${i}`];
    if (coefEspacio && coefEspacio.toString().trim() !== '') {
      coeficientesEspacios += parseFloat(coefEspacio) || 0;
    }
  }
  let coeficientesLegacy = 0;
  for (let i = 1; i <= 10; i++) {
    const coefParq = fila[`coeficiente_parqueadero_${i}`];
    if (coefParq && coefParq.toString().trim() !== '') {
      coeficientesLegacy += parseFloat(coefParq) || 0;
    }

    const coefCuarto = fila[`coeficiente_cuarto_util_${i}`];
    if (coefCuarto && coefCuarto.toString().trim() !== '') {
      coeficientesLegacy += parseFloat(coefCuarto) || 0;
    }
  }
  const coeficientesEspaciosTotal = coeficientesEspacios > 0 ? coeficientesEspacios : coeficientesLegacy;

  return coeficienteApartamento + coeficientesEspaciosTotal;
};
export const actualizarFilaEnDataset = (dataset, filaActualizada) => {
  const index = dataset.findIndex(fila => fila.id === filaActualizada.id);
  if (index !== -1) {
    const copropietarios = extraerDatosNumerados(filaActualizada, ['nombre_residente']).length;
    const vehiculos = extraerDatosNumerados(filaActualizada, ['placa']).length;
    const mascotas = extraerDatosNumerados(filaActualizada, ['nombre_mascota']).length;
    const autorizados = extraerDatosNumerados(filaActualizada, ['nombre_autorizado']).length;
    const espacios = extraerDatosNumerados(filaActualizada, ['espacio_tipo']).length;

    dataset[index] = {
      ...filaActualizada,
      copropietarios,
      vehiculos,
      mascotas,
      autorizados,
      espacios,
      coeficienteTotal: calcularCoeficienteTotal(filaActualizada)
    };
  }
  return dataset;
};